// Avatar Configuration
// One Piece themed avatar options for users

export const AVATAR_OPTIONS = [
  { id: 'pirate', emoji: '🏴‍☠️', label: 'Pirate Flag' },
  { id: 'anchor', emoji: '⚓', label: 'Anchor' },
  { id: 'sword', emoji: '🗡️', label: 'Sword' },
  { id: 'crown', emoji: '👑', label: 'Crown' },
  { id: 'fire', emoji: '🔥', label: 'Fire' },
  { id: 'lightning', emoji: '⚡', label: 'Lightning' },
  { id: 'meat', emoji: '🍖', label: 'Meat' },
  { id: 'map', emoji: '🗺️', label: 'Map' },
  { id: 'tophat', emoji: '🎩', label: 'Top Hat' },
  { id: 'skull', emoji: '💀', label: 'Skull' },
  { id: 'bone', emoji: '🦴', label: 'Bone' },
  { id: 'wave', emoji: '🌊', label: 'Wave' },
  { id: 'ship', emoji: '🚢', label: 'Ship' },
  { id: 'compass', emoji: '🧭', label: 'Compass' },
  { id: 'treasure', emoji: '💎', label: 'Treasure' },
  { id: 'sun', emoji: '☀️', label: 'Sun' },
  { id: 'moon', emoji: '🌙', label: 'Moon' },
  { id: 'star', emoji: '⭐', label: 'Star' },
  { id: 'dragon', emoji: '🐉', label: 'Dragon' },
  { id: 'octopus', emoji: '🐙', label: 'Octopus' },
];

// One Piece character avatars (images). The stored avatar value is the image
// URL; display code treats any value starting with http or / as an image.
export const CHARACTER_AVATARS = [
  { id: 'luffy', label: 'Luffy', image: 'https://cdn.myanimelist.net/images/characters/9/310307.jpg' },
  { id: 'zoro', label: 'Zoro', image: 'https://cdn.myanimelist.net/images/characters/3/100534.jpg' },
  { id: 'nami', label: 'Nami', image: 'https://cdn.myanimelist.net/images/characters/6/59914.jpg' },
  { id: 'sanji', label: 'Sanji', image: 'https://cdn.myanimelist.net/images/characters/5/136769.jpg' },
  { id: 'usopp', label: 'Usopp', image: 'https://cdn.myanimelist.net/images/characters/16/188076.jpg' },
  { id: 'chopper', label: 'Chopper', image: 'https://cdn.myanimelist.net/images/characters/3/100536.jpg' },
  { id: 'robin', label: 'Robin', image: 'https://cdn.myanimelist.net/images/characters/16/363700.jpg' },
  { id: 'franky', label: 'Franky', image: 'https://cdn.myanimelist.net/images/characters/13/210053.jpg' },
  { id: 'brook', label: 'Brook', image: 'https://cdn.myanimelist.net/images/characters/10/161005.jpg' },
  { id: 'ace', label: 'Ace', image: 'https://cdn.myanimelist.net/images/characters/2/72220.jpg' },
  { id: 'law', label: 'Law', image: 'https://cdn.myanimelist.net/images/characters/10/258757.jpg' },
  { id: 'shanks', label: 'Shanks', image: 'https://cdn.myanimelist.net/images/characters/9/307639.jpg' },
  { id: 'sabo', label: 'Sabo', image: 'https://cdn.myanimelist.net/images/characters/15/131855.jpg' },
  { id: 'hancock', label: 'Hancock', image: 'https://cdn.myanimelist.net/images/characters/14/146013.jpg' },
  { id: 'mihawk', label: 'Mihawk', image: 'https://cdn.myanimelist.net/images/characters/7/69747.jpg' },
  { id: 'whitebeard', label: 'Whitebeard', image: 'https://cdn.myanimelist.net/images/characters/3/100236.jpg' },
];

// True when an avatar value is an image (URL or local path) rather than an emoji.
export const isImageAvatar = (value) =>
  typeof value === 'string' && (value.startsWith('http') || value.startsWith('/'));

export const DEFAULT_AVATAR = '🏴‍☠️';

// Get avatar emoji by ID
export const getAvatarById = (id) => {
  const avatar = AVATAR_OPTIONS.find(a => a.id === id);
  return avatar ? avatar.emoji : DEFAULT_AVATAR;
};

// Get avatar by emoji (for backwards compatibility)
export const getAvatarEmoji = (avatarValue) => {
  // If it's already an emoji, return it
  if (avatarValue && avatarValue.length <= 4) {
    return avatarValue;
  }
  // If it's an ID, look it up
  if (avatarValue) {
    return getAvatarById(avatarValue);
  }
  return DEFAULT_AVATAR;
};
